export const enum ProfileAssetTypes {
  INSURANCE_DOCUMENT = 1, // Polisblad aansprakelijkheidsverzekering
  COMPLAINTS_DOCUMENT = 25, // certificaat klachtenregeling
  COC_DOCUMENT = 17, // kvk uitreksel
  VOG_DOCUMENT = 23, // VOG
  INSURANCE_DOCUMENT_PAYMENT_PROOF = 26, // Betalingsbewijs aansprakelijkheidsverzekering
}
